import React, { lazy, Suspense } from 'react';

const ClickUpPage = lazy(() => import('./ClickUpPage'));
const ClickUpInboxPage = lazy(() => import('./ClickUpInboxPage'));
const ClickUpTaskDetail = lazy(() => import('./ClickUpTaskDetail'));

interface ClickUpModalRouterProps {
  currentView: 'inbox' | 'tasks' | 'task-detail';
  currentTaskId?: string;
  onNavigateToInbox: () => void;
  onNavigateToTasks: () => void;
  onNavigateToTask: (taskId: string) => void;
}

const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    color: 'var(--text-secondary)',
  }}>
    <div className="cxinbox-spinner-ring" />
  </div>
);

const ClickUpModalRouter: React.FC<ClickUpModalRouterProps> = ({
  currentView,
  currentTaskId,
  onNavigateToInbox,
  onNavigateToTasks,
  onNavigateToTask,
}) => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      {currentView === 'inbox' && (
        <ClickUpInboxPage onNavigateToTask={onNavigateToTask} />
      )}
      
      {currentView === 'tasks' && (
        <ClickUpPage onNavigateToTask={onNavigateToTask} />
      )}
      
      {currentView === 'task-detail' && currentTaskId && (
        <ClickUpTaskDetail 
          taskId={currentTaskId} 
          onBack={onNavigateToInbox}
        />
      )}
    </Suspense>
  );
};

export default ClickUpModalRouter;
